export default __webpack_public_path__ + "static/media/carta4.9e570319.png";